import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'pt-widget-text-v0-preview',
  template: `
    <ng-container *ngIf="loading; then LOADING; else PREVIEW"></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>

      <ng-container *ngIf="!!previewData && previewData?.length > 0; then DATA; else NODATA"></ng-container>

      <ng-template #NODATA>
        <pt-widget-nodata [noDataLabel]="noDataLabel" *ngIf="showNoData"></pt-widget-nodata>
      </ng-template>

      <ng-template #DATA>
        <div class='pt-widget-text-preview-v0' [innerHTML]="htmlValue"></div>
      </ng-template>
    </ng-template>
  `,
  styles: [`
    .pt-widget-text-preview-v0 {
      width: 100%;
      background: none;
      padding: 8px;
      overflow-y: auto;
      height: 75px;
      border: 1px solid #cccccc;
    }
  `]
})
export class WidgetTextV0PreviewComponent implements OnChanges {
  @Input() noDataLabel?: string;
  @Input() previewData: string;
  @Input() loading: boolean;
  @Input() showNoData: boolean;

  htmlValue: string;

  ngOnChanges(): void {
    this.htmlValue = this.previewData ? this.previewData.split('\n').join('<br />') : '';
  }
}
